// extracted by mini-css-extract-plugin
export default {"directory_link":"TableView_directory_link__d8T9s","link":"TableView_link__wogAZ"};